import shopAppInit from '@/components/app';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', shopAppInit, { once: true });
} else {
  shopAppInit();
}
